import {helpCentre, HelpCentre} from "./help-centre/DashboardHelpCentreComponent";
import {clientFeatures, ClientFeatures} from "./features/ClientDashboardFeaturesComponent";
import {
    dashboardPortfolioSummary,
    DashboardPortfolioSummary
} from "./portfolio-summary/large/DashboardPortfolioSummaryComponentLarge";
import {
    portfolioSummarySmall,
    PortfolioSummarySmall
} from "./portfolio-summary/small/DashboardPortfolioSummaryComponentSmall";

import {dashboardNotifications, DashboardNotifications} from "./notifications/DashboardNotificationSettingsComponent";
import {tradingAlerts, TradingAlerts} from "./trading-alerts/DashboardTradingAlertsComponent";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/components`;

    return angular.module("tfApp.dashboard.client.components", [])
                  .component(DashboardPortfolioSummary, dashboardPortfolioSummary(rootDir))
                  .component(PortfolioSummarySmall, portfolioSummarySmall(rootDir))
                  .component(HelpCentre, helpCentre(rootDir))
                  .component(ClientFeatures, clientFeatures(rootDir))
                  .component(DashboardNotifications, dashboardNotifications(rootDir))
                  .component(TradingAlerts, tradingAlerts(rootDir))
                  .name;
}
